module.exports = __webpack_public_path__ + "img/11069864_L.18cda7d5.png";